"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7119],{

/***/ 77119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCamera = function SvgCamera(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M13.333 9.039a.333.333 0 0 0-.333.333v1.667h-2.822l-2.37-3.556 3.352-1.936a.332.332 0 0 0 .122-.455L8.948 1.051a.335.335 0 0 0-.332-.164.331.331 0 0 0-.123.042l-6.928 4a.333.333 0 0 0-.122.455l.5.866L.5 7.084a.333.333 0 0 0-.122.455l1 1.732a.334.334 0 0 0 .455.121l1.443-.833.5.867a.335.335 0 0 0 .289.166.33.33 0 0 0 .166-.045l2.998-1.73 2.493 3.74a.334.334 0 0 0 .278.149h3v1.666a.333.333 0 0 0 .666 0v-4a.333.333 0 0 0-.333-.333ZM2.943 7.982 1.79 8.65l-.667-1.155 1.154-.667.667 1.155Zm1.244.822-2-3.465 6.351-3.667 2 3.465-6.35 3.667Z"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgCamera);

/***/ })

}]);